function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var makeTreeItemStyles = function makeTreeItemStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiTreeItem: {
      styleOverrides: {
        root: {
          color: tokens.colors["ink-on-background"]
        },
        content: _objectSpread(_objectSpread({
          width: "unset",
          padding: primitives.spacings["4"],
          position: "relative",
          borderRadius: primitives.borderRadii.medium,
          zIndex: 1
        }, tokens.transitions["state-blur"]), {}, {
          "&:hover": _objectSpread({
            background: tokens.gradients["row-highlighted-hover-loud-reverse"]
          }, tokens.transitions["state-activate"]),
          "&.Mui-selected": _objectSpread(_objectSpread({
            background: "none"
          }, tokens.transitions["state-activate"]), {}, {
            "&:hover": _objectSpread({
              background: tokens.gradients["row-highlighted-hover-loud-reverse"]
            }, tokens.transitions["state-activate"])
          }),
          "&.Mui-focused": _objectSpread(_objectSpread({}, tokens.transitions["state-activate"]), {}, {
            boxShadow: tokens.effects["focus-ring-thin"],
            background: "none",
            "&:active": {
              boxShadow: "none",
              background: tokens.gradients["row-highlighted-pressed-loud-reverse"]
            }
          }),
          "&.Mui-selected.Mui-focused": {
            background: "none",
            "&:active": {
              boxShadow: "none",
              background: tokens.gradients["row-highlighted-pressed-loud-reverse"]
            }
          },
          "&.Mui-disabled": {
            background: "none"
          },
          "&:active": _objectSpread({
            boxShadow: "none",
            background: tokens.gradients["row-highlighted-pressed-loud-reverse"]
          }, tokens.transitions["state-activate"])
        }),
        group: {
          margin: "0",
          position: "relative",
          padding: "0",
          "&:before": _objectSpread(_objectSpread({
            content: '""',
            position: "absolute",
            height: "100%",
            width: "100%",
            bottom: 0,
            zIndex: 2
          }, tokens.transitions["state-blur"]), {}, {
            background: "linear-gradient(0deg, ".concat(tokens.colors["fade-gradient-opaque"], " 0%, ").concat(tokens.colors["fade-gradient-transparent"], " 100%)")
          }),
          '&[class*="MuiCollapse-entered"]:before': {
            height: "0%"
          },
          '& [class*="MuiTreeItem-root"]': {
            marginLeft: primitives.spacings["4"]
          }
        },
        label: {
          paddingRight: primitives.spacings["4"]
        }
      }
    }
  };
};